/* Store photographs advance every five seconds while the story is visible. */
(function(){
  var carousel = document.querySelector('[data-story-slideshow]');
  if (!carousel) return;
  var slides = Array.from(carousel.querySelectorAll('[data-story-slide]'));
  var pause = carousel.querySelector('[data-story-pause]');
  var count = carousel.querySelector('[data-story-count]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var index = 0, timer, visible = false, paused = reduced.matches;
  function show(next){
    index = (next + slides.length) % slides.length;
    slides.forEach(function(slide, i){
      slide.classList.toggle('is-active', i === index);
      slide.setAttribute('aria-hidden', String(i !== index));
    });
    count.textContent = (index + 1) + ' / ' + slides.length;
  }
  function schedule(){
    clearInterval(timer);
    if (visible && !paused && !document.hidden && !carousel.matches(':focus-within')) {
      timer = setInterval(function(){ show(index + 1); }, 5000);
    }
    pause.textContent = paused ? 'Play' : 'Pause';
    pause.setAttribute('aria-label', (paused ? 'Play' : 'Pause') + ' store slideshow');
  }
  carousel.querySelector('[data-story-previous]').addEventListener('click', function(){show(index - 1);schedule();});
  carousel.querySelector('[data-story-next]').addEventListener('click', function(){show(index + 1);schedule();});
  pause.addEventListener('click', function(){paused = !paused;schedule();});
  carousel.addEventListener('focusin', schedule);
  carousel.addEventListener('focusout', function(){setTimeout(schedule, 0);});
  document.addEventListener('visibilitychange', schedule);
  reduced.addEventListener('change', function(){paused = reduced.matches;schedule();});
  new IntersectionObserver(function(entries){visible = entries[0].isIntersecting;schedule();}, {threshold: .15}).observe(carousel);
  schedule();
})();

/* Keep hero link hit areas in sync with the wipe. */
(function(){
  var wrap = document.querySelector('[data-avant-homepage] .reveal-wrap');
  var split = wrap ? wrap.querySelector('.split') : null;
  if (!split) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function updateReveal(){
    var rect = wrap.getBoundingClientRect();
    var distance = rect.height - window.innerHeight;
    var progress = distance > 0 ? Math.max(0, Math.min(1, -rect.top / distance)) : 1;
    var revealed = progress >= .75;
    var mask = 'linear-gradient(158deg, transparent 150%, black 170%)';
    if (revealed){
      mask = 'none';
    } else if (!reduced.matches && progress >= .25){
      var edge = ((progress - .25) / .5) * 116;
      mask = 'linear-gradient(158deg, transparent ' + (84 - edge) + '%, black ' + (100 - edge) + '%)';
    }
    split.style.webkitMaskImage = mask;
    split.style.maskImage = mask;
    split.inert = !revealed;
    split.classList.toggle('is-revealed', revealed);
  }

  window.addEventListener('scroll', updateReveal, {passive:true});
  window.addEventListener('resize', updateReveal);
  window.addEventListener('pageshow', updateReveal);
  reduced.addEventListener('change', updateReveal);
  updateReveal();
})();

/* V6: menu open/close + ledger peek */
(function(){
  var burger = document.getElementById('burger');
  var overlay = document.getElementById('menuOverlay');
  var closer = document.getElementById('menuClose');
  function setOpen(open){
    overlay.classList.toggle('open', open);
    burger.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger && overlay){
    burger.addEventListener('click', function(){ setOpen(!overlay.classList.contains('open')); });
    if (closer) closer.addEventListener('click', function(){ setOpen(false); });
    overlay.querySelectorAll('nav a').forEach(function(a){
      a.addEventListener('click', function(){ setOpen(false); });
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') setOpen(false); });
  }
  document.querySelectorAll('.ledger .row').forEach(function(row){
    var peek = row.querySelector('.peek');
    if (!peek) return;
    row.addEventListener('mousemove', function(e){
      var r = row.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      peek.style.left = Math.min(r.width - 320, Math.max(20, x + 30)) + 'px';
      peek.style.top = (y - peek.offsetHeight * .5) + 'px';
    });
  });
})();

(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
    });
  },{threshold:0.16, rootMargin:'0px 0px -6% 0px'});
  document.querySelectorAll('[data-reveal]').forEach(function(el){ io.observe(el); });

  /* Header state */
  var bar = document.getElementById('topbar');

  /* Smooth parallax with lerp */
  var plx = [];
  document.querySelectorAll('[data-plx]').forEach(function(el){
    plx.push({el:el, speed:parseFloat(el.getAttribute('data-plx'))||0});
  });
  var drift = document.querySelector('[data-drift]');
  var slice = document.querySelector('.slice');
  var target = window.scrollY, current = target;

  function onScroll(){ target = window.scrollY; }
  window.addEventListener('scroll', onScroll, {passive:true});

  function frame(){
    current += (target - current) * 0.085;
    if(Math.abs(target-current) < 0.05) current = target;
    var vh = window.innerHeight;

    bar.classList.toggle('scrolled', target > 40);

    if(!reduced){
      plx.forEach(function(p){
        var r = p.el.getBoundingClientRect();
        var mid = r.top + r.height/2 - vh/2;
        p.el.style.transform = 'translate3d(0,' + (mid * p.speed).toFixed(2) + 'px,0)';
      });
      /* horizontal drift of collection cards */
      if(drift){
        var r = drift.getBoundingClientRect();
        var prog = Math.min(1, Math.max(0, 1 - (r.top - vh*0.1) / vh));
        drift.style.transform = 'translate3d(' + (-prog * Math.max(0, drift.scrollWidth - window.innerWidth + window.innerWidth*0.06)).toFixed(1) + 'px,0,0)';
      }
      /* two-greens seam shifts as you scroll through */
      if(slice){
        var sr = slice.getBoundingClientRect();
        var sp = Math.min(1, Math.max(0, (vh - sr.top) / (vh + sr.height)));
        slice.style.setProperty('--slice', (38 + sp*24).toFixed(2) + '%');
      }
      /* inner parallax for path/story/event imagery uses --plx-y on img wrappers */
      document.querySelectorAll('.split .half .ph img, .events .bg img, .story4 .im img, .hero.v2 .bg img').forEach(function(img){
        var rr = img.getBoundingClientRect();
        var m = (rr.top + rr.height/2 - vh/2) * 0.05;
        img.style.setProperty('--plx-y', m.toFixed(2) + 'px');
      });
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
